import { DeepPartial, FieldValues, UseFormSetValue } from 'react-hook-form';
import { TooltipOffsets } from '../InteractiveTooltip/domain';
import { ReactNode, JSX } from 'react';
import { Option } from '../Select';
import { TimeFilter } from 'src/viewsTypes';

export enum FilterType {
  SingleSelect = 'singleSelect',
  MultiSelect = 'multiSelect',
  Date = 'date',
  DateRange = 'dateRange',
  TextInput = 'textInput',
}

export enum Groups {
  Category = 'Category',
  Date = 'Date',
  Empty = '',
}

export type QuickFilter<T> = {
  field: T;
  label: string;
  targetValue: any;
  originalFieldType?: FilterType;
};

export type Filter<T> = {
  field: T;
  label: string;
  type: FilterType;
  inputPlaceholder?: string;
  groupBy?: string;
  disabled?: boolean;
  tooltipTitle?: string | ReactNode;
  options?: Option[];
  onChange?:
    | ((params: {
        data?: string | null;
        setValue?: UseFormSetValue<FieldValues>;
      }) => void)
    | ((params: {
        data?: (Option | string | null)[];
        setValue?: UseFormSetValue<FieldValues>;
      }) => void)
    | ((params: {
        data?: TimeFilter | null;
        setValue?: UseFormSetValue<FieldValues>;
      }) => void)
    | ((params: {
        data?: string;
        setValue?: UseFormSetValue<FieldValues>;
      }) => void);
};

export type FiltersConfig<T> = {
  quick?: QuickFilter<T>[];
  main: Filter<T>[];
};

export interface ChipField<T> extends Filter<T> {
  value: string | null;
}

export type FiltersProps<T extends string> = {
  formIsSubmittedOnFieldChange?: boolean;
  filtersTitle?: string;
  isDisabled: boolean;
  isParentOpen?: boolean;
  isQuickFiltersDisabled?: boolean;
  isThroughPortal?: boolean;
  filtersConfig: FiltersConfig<T>;
  initialValues: DeepPartial<Record<T, any>>;
  valuesResetTo: DeepPartial<Record<T, any>>;
  submittingMessage?: string;
  setSubmittingMessage?: (message: string) => void;
  tooltipOffsets?: TooltipOffsets;
  renderTrigger?: ({
    isOpen,
    isDisabled,
    onClick,
  }: {
    isOpen: boolean;
    isDisabled: boolean;
    onClick: () => void;
  }) => JSX.Element;
  onSubmit: (data: any) => void;
  onResetFilters: () => void;
};

export type ControlFilters = {
  date?: TimeFilter | null;
  vendors?: string[] | null;
};
export type Filters = {
  order: 'asc' | 'desc';
  orderBy: OrderBy;
  query: string;
  //
  controls?: ControlFilters;
};

export type OrderBy =
  | 'affiliate_name'
  | 'affiliate_status'
  | 'assets_amount'
  | 'violations_amount'
  | 'priority'
  | 'last_scan'
  | 'health_rank'
  | 'business_owner'
  | 'regulations'
  | 'monitoring_status'
  | 'affiliate_condition'
  | 'registration_date';
